<template>
  <div>
    <Button
      class="btn-info"
      @click="refreshPixelMetrics"
      :loading="loader"
    >
      Atualizar planilha
    </Button><br>
    <small class="mt-2" v-if="message">Atualização está sendo processada!</small>
  </div>
</template>

<script>

import IntegrationsService from '@/modules/integrations/services/integrations-service'

import Button from '@/components/common/Button/Button'

export default {
  props: ['companyId', 'advertiserId'],
  name: 'RefreshPixelMetricsButton',
  components: {
    Button
  },
  data () {
    return {
      loader: false,
      message: false
    }
  },
  methods: {
    /**
     * Refresh PixelMetrics
     */
    async refreshPixelMetrics () {
      this.loader = true
      try {
        await IntegrationsService.forceRefreshPixelMetrics({
          advertiser_id: this.advertiserId,
          company_id: this.companyId
        })
        this.message = true
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
